import { useMemo, useCallback } from 'react';
import { area, curveMonotoneX } from 'd3';
import type { SeriesDataPoint } from '../types';

type ScaleFunction = (value: number) => number;

export const useStackAreaGenerator = (xScale: ScaleFunction, yScale: ScaleFunction) => {
  const stackAreaGenerator = useCallback(
    ({ x, y }: { x: ScaleFunction; y: ScaleFunction }) => {
      return area<SeriesDataPoint>()
        .x((d: SeriesDataPoint) => x(d.year))
        .y0((d: SeriesDataPoint) => y(d.tradeValueMin))
        .y1((d: SeriesDataPoint) => y(d.tradeValueMax))
        .defined(
          (d: SeriesDataPoint) => !!d.year && d.tradeValueMin >= 0 && d.tradeValueMax >= 0
        )
        .curve(curveMonotoneX);
    },
    []
  );

  const stackArea = useMemo(
    () => stackAreaGenerator({ x: xScale, y: yScale }),
    [stackAreaGenerator, xScale, yScale]
  );

  return stackArea;
};

